<div mat-dialog-title
  class="card-title">
  <h1>{{'orderViewPage.please_select_quantity' | translate | uppercase}}</h1>
  <div (click)="onSelectQuantity()">X</div>
</div>
<div class="reason-list">
  @for (quantity of quantityList; track quantity) {
    <label
      (click)="onSelectQuantity(quantity)">
      <input type="radio"
        [ngModel]="selectedQuantity"
        [value]="quantity">
      {{quantity}}
    </label>
  }
</div>
